export default {
  userInfo: (state: any) => {
    return state.info;
  },
  getClientName: (state: any) => {
    return state.info.clientName;
  },
};
